import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import Step from '../../../../../../../features/components/Forms/StepForm/Step'
import CreateLeadAdsFormLink from '../../../../../UploadFacebookAdCreative/CreateLeadAdsFormLink'
import RefreshableInstantFormField from './RefreshableInstantFormField'

import { LEAD_GEN_FORM } from '../../../../fields'

import useDrawerFormClasses from '../../../../../../../styles/common/drawerForms'
import useStyles from './styles'

const stepFields = [LEAD_GEN_FORM]

const InstantFormSelectionStep = ({ formik, handleStepChange }) => {
  const classes = useStyles()
  const drawerFormClasses = useDrawerFormClasses()
  const { t } = useTranslation()

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields)
  }, [handleStepChange])

  return (
    <Step stepTitle="Select an Instant Form" handleContinue={handleContinue}>
      <section className={drawerFormClasses.section}>
        <p className={classes.subTitle}>{t('Lead Ads Instant Forms')}</p>
        <CreateLeadAdsFormLink />
        <RefreshableInstantFormField formik={formik} />
      </section>
    </Step>
  )
}

export default InstantFormSelectionStep
